import { render } from "./NavWithApartmentName.vue?vue&type=template&id=389c13e5"
import script from "./NavWithApartmentName.vue?vue&type=script&lang=js"
export * from "./NavWithApartmentName.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__